import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import styled from 'styled-components';
import { components } from '@atlaskit/select';
import { SizeableAvatar } from './SizeableAvatar';
import { BORDER_PADDING } from './styles';
var PlaceholderIconContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n  line-height: 0;\n"])), BORDER_PADDING);

var showUserAvatar = function showUserAvatar(inputValue, value) {
  return value && value.data && inputValue === value.label;
};

export var SingleValueContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleValueContainer, _React$Component);

  var _super = _createSuper(SingleValueContainer);

  function SingleValueContainer() {
    var _this;

    _classCallCheck(this, SingleValueContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props = _this.props,
          hasValue = _this$props.hasValue,
          _this$props$selectPro = _this$props.selectProps,
          appearance = _this$props$selectPro.appearance,
          isFocused = _this$props$selectPro.isFocused,
          inputValue = _this$props$selectPro.inputValue,
          value = _this$props$selectPro.value;

      if (isFocused || !hasValue) {
        return /*#__PURE__*/React.createElement(SizeableAvatar, {
          appearance: appearance,
          src: showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
        });
      }

      return null;
    });

    return _this;
  }

  _createClass(SingleValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          valueContainerProps = _objectWithoutProperties(_this$props2, ["children"]);

      return /*#__PURE__*/React.createElement(components.ValueContainer, valueContainerProps, /*#__PURE__*/React.createElement(PlaceholderIconContainer, null, this.renderAvatar()), children);
    }
  }]);

  return SingleValueContainer;
}(React.Component);